import { useContext } from 'react';
import { CandidateContext } from 'context/CandidateContext';

const useCandidateContext = () => {
  const ctx = useContext(CandidateContext);
  return { ...ctx };
};

export default useCandidateContext;
